// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import core from '@bmp-vue/core'
import modules from '@/plugins/store/modules'
import Vue from 'vue'
import hacktimer from 'hacktimer'
import ui from '@/api/ui.js'

core.carregaEnum = false
core.defaultViews = false

core.extendRouterBeforeEach = function (vm, to, from, next) {
  const permite = vm.$empresa && vm.$empresa.codigo && vm.$empresa.codigo !== vm.global.GuidEmpty
 
  if (to.fullPath === '/authcompany' && permite) {
    return false
  }

  if (vm.$store._actions['default/beforeEach']) {
    vm.$store.dispatch('default/beforeEach', { to, from, next })
  }

  let partner = JSON.parse(localStorage.getItem('parceiros'));
  if(Array.isArray(partner))
    partner = partner.find(x => x.value == vm.$empresa.codigo);

  if (partner) {
    if (to.meta.allParametersRequired) {
      return to.meta.parameters.every(param => partner[param]);
    }
    if (to.meta.parameters) {
      return to.meta.parameters.some(param => partner[param]);
    }
  }

  return permite
}

core.extendEmpresa = function (data, callback) {
  callback(data)
}

const controllers = require.context(
  '@/controllers', true, /\.js$/
)
core.methods.init(controllers)

core.api.Functions = require('@/functions').default

core.api.UI = {...core.api.UI, ...ui}

modules.forEach(p => {
  core.store.registerModule(p.name, p)
})

function isApiLoaded () {
  setTimeout(function () {
    if (core.store.getters.loading || core.store.getters.activeRequests > 0) {
      isApiLoaded()
      return false
    }

    require('@/components/')

    const theme = require('theme').default

    const paths = require('@/plugins/router/paths').default
    const App = () => import('./App')

    Vue.use(hacktimer)
    core.methods.finish(paths, theme, App)
  }, 100)
}

isApiLoaded()
